// extracted by mini-css-extract-plugin
export default {"content":"style_content__AzF3k","itemName":"style_itemName__uci0j"};